const BaseURL = "https://sociout-dev.fly.dev/api/";
// const BaseURL = "http://localhost:8000/api/";

const PhotoURL = "https://storage.googleapis.com/sociout-data/";

export { BaseURL, PhotoURL };
